import { Pipe, PipeTransform } from '@angular/core';
import { MoneyPipe } from '@x/common/money/money.pipe';
import {
  IShopCurrency,
  IShopProductVariant,
  IShopProductVariation,
} from '@x/ecommerce/shop-client';

@Pipe({
  name: 'productPrice',
})
export class ProductPricePipe implements PipeTransform {
  constructor(private money: MoneyPipe) {}

  transform(
    product: { variation: IShopProductVariation; variants: IShopProductVariant[] },
    price?: IShopCurrency,
  ): string | null {
    if (price) return this._transForm(price);

    const { variation, variants } = product;

    const shopCurr: IShopCurrency = variants[0].price;

    if (variation === 'OPTION') {
      const variationCurr = variants.reduce((acc, varient) => {
        return acc.amount < varient.price.amount ? acc : varient.price;
      }, {} as IShopCurrency);

      return `From ${this._transForm(variationCurr)}`;
    }

    return this._transForm(shopCurr);
  }

  private _transForm(price: IShopCurrency): string | null {
    return this.money.transform(price.amount, price.currency);
  }
}
